import apiClient from '../lib/apiClient'

export const chatService = {
  /**
   * Find or create a conversation for a character within a player session.
   * Backend scopes by (user_id, story_id, character_id) and links to session.
   */
  async getOrCreateConversation(playerSessionId, characterId) {
    const response = await apiClient.post(
      `/api/player_sessions/${playerSessionId}/conversations`,
      { character_id: characterId }
    )
    return response.data.data || response.data
  },

  /**
   * Send a chat message to trigger AI character response.
   * The HTTP response is minimal — actual content streams via ChatsChannel.
   */
  async sendMessage({ messages, chatId, characterId, storyId }) {
    const response = await apiClient.post('/api/stories/generate', {
      messages,
      chat_id: chatId,
      character_id: characterId,
      story_id: storyId,
    })
    return response.data.data || response.data
  },
}
